import React from 'react';
import PropTypes from 'prop-types';
import { GET_FABRIC_DATA } from 'mocks/queries';

import addDomainToPath from 'commons/addDomainToPath';
import JBImage from 'components/essentials/JBImage';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import SanitizedHtml from '../SanitizedHtml';

const MaterialSwatch = ({
  fabricValueName,
  fabricDescription,
  fabricImage,
  fabricValueId,
}) => {
  const { data, loading, error } = useSuspenseQuery(GET_FABRIC_DATA, {
    variables: {
      fabricValueId,
    },
  });

  const fabricData = data?.getFabrics;

  if (loading || error || (!fabricData && !fabricValueName)) return null;
  return (
    <div className="flex flex-row items-start pb-6 max-[765px]:flex-col max-[765px]:mt-6">
      <div className="flex items-center min-w-[200px] max-[765px]:w-full max-[765px]:items-center max-[765px]:justify-center">
        <div className="w-full max-[765px]:w-[unset]">
          <JBImage
            width={165}
            height={165}
            src={addDomainToPath(
              `/option_images/swatches/165x165-${fabricData?.[0]
                ?.option_image || fabricImage}`
            )}
          />
        </div>
      </div>

      <div className="flex flex-1 flex-col items-start ml-6 text-gray">
        <div className="text-[1.2rem] leading-[2.375rem] tracking-[-.02em] mt-0 mx-0 mb-[1.1rem] font-normal text-gray">
          {fabricData?.[0]?.option_value || fabricValueName}
        </div>

        <SanitizedHtml
          html={fabricData?.[0]?.option_description || fabricDescription}
        />
      </div>
    </div>
  );
};

MaterialSwatch.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool,
    error: PropTypes.string,
    getFabrics: PropTypes.func,
  }),
  fabricValueName: PropTypes.string,
  fabricDescription: PropTypes.string,
  fabricImage: PropTypes.string,
};

export default MaterialSwatch;
